export const getBuyerLeadOutcome = (
  stageStatus: string | null | undefined,
) => ({
  isWon: stageStatus === 'won',
  isLost: stageStatus === 'lost',
});
